const header = (): void => {
  const burgerButton: HTMLElement | null = document.querySelector('.l-header__burger');
  const nav: HTMLElement | null = document.querySelector('.l-header__nav');

  if (burgerButton && nav) {
    burgerButton.addEventListener('click', () => {
      burgerButton.classList.toggle('is-active');
      nav.classList.toggle('is-active');
    });
  }

  // リンククリックでメニューを閉じる
  const navLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.l-header__nav a');
  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      if (burgerButton && nav) {
        burgerButton.classList.remove('is-active');
        nav.classList.remove('is-active');
      }
    });
  });

  const topButton: HTMLElement | null = document.querySelector('.l-footer__top');
  window.addEventListener('scroll', () => {
    if (topButton) {
      if (window.scrollY > 100) {
        topButton.classList.add('is-active');
      } else {
        topButton.classList.remove('is-active');
      }
    }
  });
};

export default header;
